import React from 'react';
import LazyTable from 'app/component/lazy-table';
import { Checkbox } from 'primereact/checkbox';
import { formatDateFromInstant } from 'app/shared/util/date-utils';

const ClientRequestTable: React.FC = () => {
  const showToClientCheckbox = zaplatene => {
    return <Checkbox disabled={true} style={{ marginLeft: '1rem' }} checked={zaplatene as boolean} />;
  };

  const showExclamation = zaplatene => {
    return zaplatene ? <i className="pi pi-exclamation-triangle" style={{ color: 'red' }}></i> : null;
  };

  return LazyTable({
    initialSortField: 'id',
    initialSortDirection: 'desc',
    createUrl: '1',
    serverUrl: '/api/client-request-message/byType/1',
    editActionAllowed: true,
    searchAllowed: false,
    globalFilterFields: ['businessName', 'firstName', 'lastName', 'email'],
    columns: [
      { field: 'id', header: 'ID', sortable: true },
      { field: 'hasUnseen', header: 'Neprečítané správy', sortable: true, formatter: showExclamation },
      { field: 'resolved', header: 'Vybavené', sortable: true, formatter: showToClientCheckbox },
      { field: 'createdDate', header: 'Vytvorené dňa', sortable: true, formatter: formatDateFromInstant },
      { field: 'client.firstName', header: 'Prvé meno', sortable: true },
      { field: 'client.lastName', header: 'Priezvisko', sortable: true },
      { field: 'client.businessName', header: 'Firma', sortable: true },
    ],
  });
};

export default ClientRequestTable;
